import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

import { resolveRowKeyForDataKey } from '@/utils/table-cell-value'

interface TimeSeriesChartProps {
  data: Array<{
    [key: string]: any
  }>
  dataKey: string
  xAxisKey?: string
  title?: string
  color?: string
  unit?: string
  loading?: boolean
}

export function TimeSeriesChart({
  data,
  dataKey,
  xAxisKey = 'year',
  title,
  color = '#10b981',
  unit = '',
  loading = false,
}: TimeSeriesChartProps) {
  if (loading) {
    return (
      <div className="bg-white border rounded-lg p-6">
        {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
        <div className="h-[300px] flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
        </div>
      </div>
    )
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-white border rounded-lg p-6">
        {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No hay datos disponibles
        </div>
      </div>
    )
  }

  const sample = data[0] as Record<string, unknown>
  const resolvedX = resolveRowKeyForDataKey(sample, xAxisKey)
  const resolvedY = resolveRowKeyForDataKey(sample, dataKey)

  return (
    <div className="bg-white border rounded-lg p-6">
      {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey={resolvedX}
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
            tickFormatter={(value) => `${value.toLocaleString('es-ES')}${unit ? ' ' + unit : ''}`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '12px',
            }}
            formatter={(value: number) => [
              `${value.toLocaleString('es-ES')}${unit ? ' ' + unit : ''}`,
              resolvedY,
            ]}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey={resolvedY}
            name={resolvedY}
            stroke={color}
            strokeWidth={2}
            dot={{ fill: color, r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
